import { addBusinessOperation } from "../../../../actions/Utilities/BusinessOperation";
import { useMutation } from "react-query";

const useAddBusinessOperation = () => {
  return useMutation(addBusinessOperation);
};
export default useAddBusinessOperation;
